'use strict';

export default ['$scope', '$uibModalInstance', 'ProjectService', 'Notification', 'filters', 'searchs',
    function($scope, $modalInstance, ProjectService, Notification, filters, searchs) {
        $scope.loading = false;
        $scope.emails = [];
        $scope.form = {
            "filters": filters,
            "searchs": searchs,
            "subject": "",
            "message": "",
            "includeAuthor": true,
            "includeManager": false
        };
        $scope.updateEmails = updateEmails;
        updateEmails();

        function updateEmails() {
            $scope.loading = true;
            ProjectService.api.emails({
                filters: $scope.form.filters,
                includeAuthor: $scope.form.includeAuthor,
                includeManager: $scope.form.includeManager,
            }).$promise
            .then(result => {
                $scope.emails = result._embedded || [];
                $scope.loading = false;
            })
            .catch((err) => {
                $scope.loading = false;
                console.log(err);
            })
        }

        $scope.acceptorStatusMap = {
            "AUTHOR": "Инициатор",
            "MANAGER": "Менеджер"
        }

        $scope.ok = function () {
            $scope.loading = true;
            ProjectService.api.message(null, $scope.form).$promise
            .then(() => {
                $scope.loading = false;
                Notification.success({
                    message: "Уведомления успешно отправлены"
                });
                $modalInstance.close();
            })
            .catch(err => {
                console.log(err);
                $scope.loading = false;
                Notification.danger({
                    title: 'Ошибка!',
                    message: err.toString()
                });
            })
        };

        $scope.cancel = function () {
            $modalInstance.dismiss();
        };
}]